
import { useNavigate } from 'react-router-dom';
import './HomeHero.scss';
import logo from "../../assets/Images/Home/Hero/logo.svg"
import bg from "../../assets/Images/Home/Hero/bg.svg"
import arrow from "../../assets/Images/Home/Hero/arrow-right.svg"   

//capsules imports
import iot from "../../assets/Images/Home/Hero/iot.svg"
import stearing_wheel from "../../assets/Images/Home/Hero/stearing-wheel.svg"
import truck from "../../assets/Images/Home/Hero/truck.svg"
import network from "../../assets/Images/Home/Hero/network.svg"
import healthcare from "../../assets/Images/Home/Hero/healthcare.svg"
import bag from "../../assets/Images/Home/Hero/bag.svg"

const HomeHero = () => {
  const navigate = useNavigate();
  // Capsule data with varied animation durations to make the floating feel organic
  const capsules = [
    { id: 1, label: 'Automotive', top: '-10%', left: '15%', duration: 5.5, delay: 0, icon: stearing_wheel },
    { id: 2, label: 'Transportation', top: '-5%', left: '48%', duration: 6.2, delay: 0.8, icon: truck },
    { id: 3, label: 'IOT', top: '-8%', left: '80%', duration: 5.8, delay: 1.5, icon: iot },
    { id: 4, label: 'Consumer Electronics', top: '85%', left: '5%', duration: 6.5, delay: 0.4, icon: network },
    { id: 5, label: 'Ecommerce', top: '90%', left: '42%', duration: 5.6, delay: 1.2, icon: bag },
    { id: 6, label: 'Healthcare', top: '85%', left: '70%', duration: 6.0, delay: 2.0, icon: healthcare },
  ];

  return (
    <section className="home-hero">
      {/* Background Blur Ellipse */}
      <div className="hero-bg-glow">
        <img src={bg} alt="bg" aria-hidden="true" />
      </div>

      <div className="hero-container">
        
        {/* Top Floating Graphic Section */}
        <div className="logiqlink-wrapper">
          {/* Main SVG Text */}
        <img src={logo} alt="logo" aria-hidden="true" />

          {/* Floating Glassmorphism Capsules */}
          {capsules.map((capsule) => (
            <div
              key={capsule.id}
              className="glass-capsule"
              style={{
                top: capsule.top,
                left: capsule.left,
                '--float-duration': `${capsule.duration}s`,
                '--float-delay': `${capsule.delay}s`,
              }}
            >
              <div className="capsule-content">
                <img src={capsule.icon} alt={capsule.label} className="capsule-icon" aria-hidden="true" />
                <span>{capsule.label}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Typography Section */}
        <div className="hero-text-content">
          <h1 className="hero-heading">
            Powering Intelligent Enterprises with
            <br />
            <span className="highlight-box">Future-Ready Technology</span>
          </h1>
          
          <p className="hero-subheading">
            We design, engineer, and scale AI-powered platforms, IoT products, and secure digital systems for businesses that can’t afford failure.
          </p>
        </div>

        {/* CTA Section */}
        <div className="hero-cta-group">
          <button className="btn-primary" onClick={() => navigate('/contact')}>
            Schedule a Free Consultation
            <img src={arrow} alt="arrow right" className="btn-icon" />
          </button>
          <button className="btn-secondary" onClick={() => navigate('/contact')}>
            Build Your Solution in 30 Seconds
          </button>
        </div>

      </div>
    </section>
  );
};

export default HomeHero;